import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  FormFeedback,
  Col,
  Row,
  Label,
  Form,
  Input,
  Card,
  CardBody,
  Modal,
  Button,
} from "reactstrap"
import * as Yup from "yup"
import Swal from "sweetalert2"

import { addManpowerInTicket, addMaterialInTicket } from "helpers/fakebackend_helper"
import { getMaterialMasterForServiceRequest, getServiceRequestTicketDetail, getUnitMasterForServiceRequest } from "store/actions"

const LargeModal = ({ isOpen, toggle, id }) => {
  const dispatch = useDispatch()

  const materialMasterState = state => state.serviceRequests.materials.data
  const materialMaster = useSelector(materialMasterState) || []

  const unitMasterState = state => state.serviceRequests.units.data
  const unitMaster = useSelector(unitMasterState) || []

  useEffect(() => {
    
    dispatch(getMaterialMasterForServiceRequest())
    dispatch(getUnitMasterForServiceRequest())
  }, [dispatch])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      manpower: []
    },

    validationSchema: Yup.object({
      
    }),
    onSubmit: async values => {
      
      let loadingSwal
      try {
        loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })

        const response = await addManpowerInTicket(id, values)

        if (response && response.status === true) {
          loadingSwal.close()

          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Your Manpower has been updated.",
          }).then(result => {
            if (result.isConfirmed) {
              dispatch(getServiceRequestTicketDetail(id))
              toggle()
            }
          })

        } else {
          loadingSwal.close()

          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Your Manpower has not been updated.",
          })
        }
      } catch (error) {
        console.error("Error:", error)
        if (loadingSwal) {
          loadingSwal.close()
        }

        Swal.fire({
          title: "Error",
          icon: "error",
          text:
            error.response?.data?.message ||
            "An error occurred while updating your Manpower.",
        })
      }
    },
  })

  

 
  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
         Add Manpower
        </h5>
        <button
          onClick={toggle}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Card>
          <CardBody>
            <Form
              autoComplete="off"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
                <Row>
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Labour Type</th>
                        <th>Quantity</th>
                        <th>Amount/Unit</th>
                        <th>Total</th>
                        <th>Upload Quotation File</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Input
                            type="text"
                            name={`manpower[0].label_required`}
                            value={validation?.values?.quantity}
                            onChange={validation.handleChange}
                            placeholder="Enter Labour"
                          />
                        </td>

                        <td>
                          <Input
                            type="text"
                            name={`manpower[0].quantity`}
                            value={validation?.values?.quantity}
                            onChange={validation.handleChange}
                            placeholder="Enter Quantity"
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            name={`manpower[0].cost_per_unit`}
                            value={validation?.values?.cost_per_unit}
                            onChange={validation.handleChange}
                            placeholder="Enter Amount/Unit"
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            name={`manpower[0].total`}
                            disabled
                            value={
                              (validation?.values?.manpower[0]?.quantity *
                              validation?.values?.manpower[0]?.cost_per_unit) || 0
                            }
                            onChange={validation.handleChange}
                            placeholder="Enter Total"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            id={`manpower[0].file_path`}
                            name={`manpower[0].file_path`}
                            onChange={e => {
                              const selectedFile = e.target.files[0]
                              validation.setFieldValue(
                                `manpower[0].file_path`,
                                selectedFile
                              )
                            }}
                            onBlur={validation.handleBlur}
                            className={`form-control ${
                              validation.touched[
                                `manpower[0].file_path`
                              ] &&
                              validation.errors[`manpower[0].file_path`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row>
                <div className="mb-3 mt-4 text-center">
                  <button type="submit" className="btn btn-primary ">
                    Add Manpower
                  </button>
                </div>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  )
}

export default LargeModal
